import React from 'react';
import memoize from 'lodash-es/memoize';

import { useOptionalHermes } from 'ha/modules/Hermes';
import { HermesData, PromotedBlogContent } from '../../types';

interface SearchResultsContentCardHook {
  isContentCardAvailable: boolean;
  contentCard: PromotedBlogContent | null;
}

const useSearchResultsContentCard = (
  resultsCount: number,
): SearchResultsContentCardHook => {
  const [index, setIndex] = React.useState<number | undefined>(undefined);
  const [contentCard, setContentCard] =
    React.useState<PromotedBlogContent | null>(null);
  const { data } = useOptionalHermes<HermesData>();

  const getRandomInt = memoize((max: number) =>
    Math.floor(Math.random() * Math.floor(max)),
  );

  const getIndex = React.useCallback(() => {
    if (index !== undefined) {
      return index;
    }
    const newIndex = getRandomInt(data?.promotedContent.length || 0);
    setIndex(newIndex);
    return newIndex;
  }, [data?.promotedContent.length, getRandomInt, index]);

  React.useEffect(() => {
    if (data?.promotedContent && data.promotedContent.length > 0) {
      setContentCard(data.promotedContent[getIndex()]);
    }
  }, [data, getIndex]);

  const isContentCardAvailable = React.useMemo(
    () => !!contentCard && resultsCount >= 3,
    [contentCard, resultsCount],
  );

  return {
    isContentCardAvailable,
    contentCard,
  };
};

export { useSearchResultsContentCard };
